import { Box, Card, Container, Divider, Grid, Paper, Tab } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import {
  resetAddForm,
  submitAddForm,
  loader as loading,
} from "src/app-redux/warehouse/wareHouseSlice";
import CommonButton from "src/components/CommonButton/CommonButton";
import CommonTabs from "src/components/CommonTabs/CommonTabs";
import TabHeader from "src/components/TabHeader/TabHeader";
import { WereHouseRoute } from "./../../were-house.routes";
import { AddItemInput } from "./components/AddItemInput/AddItemInput";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    pageHeading: {
      fontSize: theme.typography.pxToRem(20),
      color: "#000",
      lineHeight: "28px",
    },
    breadcrumbs: {
      fontSize: theme.typography.pxToRem(12),
    },
    backdrop: {
      zIndex: theme.zIndex.modal + 1,
      color: "#fff",
    },
    ".hidden": {
      overflow: "hidden",
    },
    accordionsSection: {
      overflow: "auto",
    },
    seeMoreBlock: {
      maxWidth: "150px",
    },
    moreInfoBlock: {
      width: "100%",
      display: "none",
      background: "#f6f6f6",
      position: "absolute",
      top: "40px",
      paddingBottom: "10px",
    },
    ".seeMoreBlock:hover > .moreInfoBlock": {
      background: "red",
    },
    cardMainParent: {
      float: "left",
      width: "100%",
    },
    tabCard: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      boxShadow: "none",
      borderRadius: "0px",
      borderRight: `1px solid ${theme.palette.divider}`,
    },
    tabCardContent: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      boxShadow: "none",
      borderRadius: "0px",
    },
    cardMain: {
      marginBottom: "30px",
      paddingTop: "10px",
      width: "calc(100%)",
    },
  })
);

function a11yProps(index: any) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

type Props = {};
export function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}
export default function AddInventoryItem({}: Props): React.ReactElement {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const [value, setValue] = useState(0);
  const [expandedAccordion, setExpandedAccordion] = useState({
    AddItemInput: false,
    doc: false,
    ivr: false,
  });
  const loader: any = useAppSelector(loading);

  const moduleName = WereHouseRoute.title;
  const pageHeading = WereHouseRoute.subRoutes ? WereHouseRoute.subRoutes[0].title : "Page Title";

  useEffect(() => {
    dispatch(resetAddForm());
  }, []);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
    setExpandedAccordion({
      ...expandedAccordion,
      AddItemInput: newValue === 0,
      doc: newValue === 1,
      ivr: newValue === 2,
    });
  };

  const updateExpandedStatus = (type: number) => {
    setValue(type);
    switch (type) {
      case 0:
        setExpandedAccordion((prev) => {
          return {
            ...prev,
            AddItemInput: !prev.AddItemInput,
          };
        });
        return;
      default:
        return;
    }
  };

  const listener = async (e: any) => {
    if (
      (e.key === "s" || e.key === "S") &&
      (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey)
    ) {
      e.preventDefault();
      if (!loader) {
        await dispatch(submitAddForm());
      }
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [loader]);

  return (
    <>
      <TabHeader module={moduleName} heading={pageHeading} link={"/gate-entry"} />
      <Box m={2} />
      <Grid container direction="row">
        <Grid item xs={12} md={12} className={classes.cardMainParent}>
          <Paper elevation={3} className={classes.cardMain}>
            <Box pl={2} pr={2}>
              <Grid container direction="row">
                <Grid item xs={12} md={9}>
                  <Typography className={classes.pageHeading}>{pageHeading}</Typography>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Box textAlign="right" mt={1}>
                    <CommonButton
                      cssClass="customSubmitBtn"
                      onClick={() => {
                        dispatch(resetAddForm());
                      }}
                    >
                      Reset
                    </CommonButton>
                    <CommonButton
                      cssClass="customSubmitBtn"
                      isGreen
                      onClick={() => {
                        dispatch(submitAddForm());
                      }}
                    >
                      Save
                    </CommonButton>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box m={1}>
              <Divider />
            </Box>

            <Grid container>
              <Grid item xs={4} md={3} lg={2} component={Card}>
                <div className="gateIn">
                  <CommonTabs value={value} handleChange={handleChange} tabMinHeight={900}>
                    <Tab label="Item Details" {...a11yProps(0)} />
                  </CommonTabs>
                </div>
              </Grid>
              <Grid item xs={8} md={9} lg={10} component={Card} className={classes.tabCardContent}>
                <Container className="gateInTabs">
                  <>
                    <AddItemInput
                      expand={expandedAccordion.AddItemInput}
                      updateExpandStatus={updateExpandedStatus}
                    />
                  </>
                </Container>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}
